import { Component, OnInit, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { kpi, sla, filecontent, kpitarget } from './../../../models/slakpi';
import { division, user, department, targetMaster } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import { ToasterService } from '../../../toaster.service';


@Component({
  selector: 'app-sla',
  templateUrl: './sla.component.html',
  styleUrls: ['./sla.component.css']

})
export class SLAComponent implements OnInit {
  
  showMyContainer: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;

  headerTitle: string;
  @ViewChild('editSettingsTemplate', { static: false }) editSettingsTemplate: TemplateRef<any>;
  public defaultyear: number = 0;
  public selected_kpiUno: number = 0;
  public kpiTargetForm: FormGroup;
  public yearsArray: FormArray;
  public selected_schedule: number = 1;
  public submitClicked: boolean = false;

  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public slaTypeUno_data: any;
  public target_data: any;
  public trend_data: any;
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;
  public frequency_data: any;
  public selected_kpiCode: string = '';
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public orderData: object;
  public kpiData: object[];
  public kpiForm: FormGroup;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isShow = false;
  public uploadedFiles: Array<File> = [];


  public permission: number = 1;
  public divisionUno_filter: number = 0;
  public checkbox_filter: boolean = false;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  objSLA: any = new sla();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter

  public sli_data: any;

  SLAno: string;
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
    searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  isInternalAudit: boolean = false;
  constructor(private formBuilder: FormBuilder, public restApi: SLAKPIApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.defaultyear = this.user.currentYear;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;

    if (!this.isAdmin) {
      this.CheckUserPermission();
    } else {
      this.permision_add = true; 
      this.permision_edit = true;
      this.permision_delete = true;

    }

  }



  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      //frozenColumn: 3,
    

    };
    this.loadSLA();
    this.getDivisions();
    this.getSLAType();
    this.getUsers();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.slaReference && a.slaReference.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.slaNameEn && a.slaNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaTypeNameEn && a.slaTypeNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.reportingAccName && a.reportingAccName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.businessAccNameEn && a.businessAccNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.fSignOffDate && a.fSignOffDate.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'slaReference', name: 'SLA Reference', field: 'slaReference', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaReference', 'slaReference'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'slaNameEn', name: 'SLA', field: 'slaNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaNameEn', 'slaNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'slaTypeNameEn', name: 'SLA Type', field: 'slaTypeNameEn', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaTypeNameEn', 'slaTypeNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'reportingAccName', name: 'First Party', field: 'reportingAccName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reportingAccName', 'reportingAccName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'businessAccNameEn', name: 'Second Party', field: 'businessAccNameEn', selectable: false, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'businessAccNameEn', 'businessAccNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'fSignOffDate', name: 'Signoff Date', field: 'fSignOffDate', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'fSignOffDate', 'fSignOffDate'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isInternalAudit)
                  return false;
                else return true;
              },
              action: (e, args) => {
                this.pageAction = 'edit';
              
                
                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  this.selTab = true;
                  this.SLAno = rdata.id;
                  this.uploadedFiles = [];
                  this.getFiles(rdata.id);
                  this.objSLA = this.data.filter((items: any) => items.slaUno == rdata.id)[0];
                  this.objSLA.signOffDate = formatDate(this.objSLA.signOffDate,'yyyy-MM-dd','en-US');
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            {
              command: 'target-row', titleKey: 'Target_ROW', positionOrder: 62, title: 'Target',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isAdmin)
                  return true;
                else return false;
              },
              iconCssClass: 'fa fa-bullseye', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';

                
                if (this.permission == 1) {
                  this.submitClicked = false;
                  let objdata: any = args.dataContext;
                  this.createFormGroup(objdata);
                  this.headerTitle = 'Details of ' + objdata.slaNameEn + " | " + 'Quarterly';
                  this.selected_schedule = 3;//objdata.scheduleUno;
                  this.selected_kpiUno = objdata.id;//objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno;
                  this.addItem(this.selected_kpiUno, this.selected_schedule);
                  this.modalRef = this.modalService.show(
                    this.editSettingsTemplate,
                    Object.assign({}, {
                      class: 'gray modal-xl modal-full',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'attachment-row', titleKey: 'VIEW_ROW', positionOrder: 63, title: 'Attachment',
              iconCssClass: 'fa fa-files-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';

                
                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  if (rdata.attachmentCount < 1) {
                   // Swal.fire('Error', 'No Data Available', 'info');
                    this.toaster.show('error', 'Error', 'No Data Available');
                    return;
                  }
                  this.selTab = true;
                  this.getFiles(rdata.id)
                  this.modalRef = this.modalService.show(
                    this.attachmentTemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isInternalAudit)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteSLA(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                    this.loadSLA();
                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };




  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        this.data = uniqBy(data, 'slaUno');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          mockDataset[i] = {
            id: this.data[i].slaUno,
            slaReference: this.data[i].slaReference,
            slaNameEn: this.data[i].slaNameEn,
            slaTypeNameEn: this.data[i].slaTypeNameEn,
            reportingAccName: this.data[i].reportingAccName,
            businessAccNameEn: this.data[i].businessAccNameEn,
            fSignOffDate: this.data[i].fSignOffDate,
            attachmentCount: this.data[i].attachmentCount
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.kpiData = this.data
        this.loading = false;
        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getSLAType() {

    let inpValue = new sla();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getSLATypes(inpValue)
      .subscribe(data => {
        this.slaTypeUno_data = data;

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getUsers() {

    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  DeleteSLA(data1: any) {

    let objDeaprtment = new sla();
    objDeaprtment.actionType = this.pageAction;
    objDeaprtment.slaUno = data1.id;
    objDeaprtment.userUno = this.login_UserID;
    objDeaprtment.tenantUno = 1;

    this.restApi.deleteSLA(objDeaprtment)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'SLA deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'SLA deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSLA();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }
  uploadFiles() {
    this.spinner.show();
    
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();
      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

      if (allowFile) {
        this.restApi.SLAFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, this.SLAno).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }
  }

  DuplicateNameCheck(slaUno: number, slaNameEn: string, slaNameAr: string) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {

        if ((slaUno != grdData.slaUno) && (grdData.slaNameEn.toLocaleLowerCase() == slaNameEn.toLocaleLowerCase() || grdData.slaNameAr.toLocaleLowerCase() == slaNameAr.toLocaleLowerCase())) {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }


  onClickAttachment(SLAno: string): void {
    
    this.getFiles(SLAno);
  }

  AddEditSLA(data1: any) {
    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.slaUno), this.utilityService.isStringNull(data1.slaNameEn), this.utilityService.isStringNull(data1.slaNameAr))) {
      this.toaster.show('error', 'Error', 'Duplicates are not allowed.');
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      return;


    }
    else {
      this.objSLA.actionType = this.pageAction;
      this.objSLA.slaUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.objSLA.slaUno);
      this.objSLA.userUno = this.login_UserID;
      this.objSLA.tenantUno = this.tenantUno;
      this.objSLA.fileName = "";
      this.objSLA.contentType = "";
      
      if (this.fileContent != null && this.fileContent != undefined && this.fileContent.fileName != '') {
        this.objSLA.fileName = this.fileContent.fileName;
        this.objSLA.contentType = this.fileContent.contentType;

      }
      this.spinner.show();
      this.restApi.addEditSLA(this.objSLA)
        .subscribe(data => {

          if (data == null && data != undefined && data != '' && (data.toString().indexOf('MSID_') <= 0)) {
           // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
          }
          else {
            this.toaster.show('success', 'Success', 'SLA saved.');
            //Swal.fire({
            //  type: 'success',
            //  title: 'SLA saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            
            this.modalRef.hide();
            this.SLAno = (this.pageAction == "add") ? data.toString() : this.SLAno;
            this.uploadFiles();
          }
          setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
    }
  }

  getFiles(slaUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = slaUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.SLAno = slaUno;
    this.restApi.SLA_FileSelect(inpValue)
      .subscribe(data => {
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();
       
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  DeleteAttachment(itemUno: string) {

    //});
    
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = itemUno;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_FileDelete(inpValue)
      .subscribe(data => {
        this.getFiles(this.SLAno);
        //setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }



  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.pageAction == "add";
    this.uploadedFiles = [];
    this.objSLA = new sla();
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }


  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }
  onNext(val) {
    if (val) {
      this.selTab = false;
    }
    else {
      //Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('error', 'Please enter the General Information.');
    }
  }
  onSubmit(val) {
    if (!val) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('error', 'Please enter the General Information.');
      this.selTab = true;
    }
    else {
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        //Check file count 
        if (this.uploadedFiles.length > 5) {
          this.toaster.show('error', 'Error', 'Attachment - Maximum 5 Files to be upload.');
          return false;
        }

        for (var i = 0; i < this.uploadedFiles.length; i++) {
          let fileName = this.uploadedFiles[i].name.toLowerCase();
          let fileSize = this.uploadedFiles[i].size;
          //Check file size
          if (!this.userService.checkFileSize(fileSize)) {
            this.toaster.show('error', 'Error', 'Attachment - A file size should not above 30MB.');
            return false;
          }
          //To check file exe
          if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
            this.toaster.show('error', 'Error', 'Attachment - Please select the correct format file.');
            return false;
          }
        }
      }

      this.AddEditSLA(this.objSLA)
    }
  }

  createFormGroup(data1: any) {

    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }
  createyearItem(objkpitarget: kpitarget): FormGroup {
    
    return this.formBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addItem(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 2;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getKpiTargets(inpValue)
      .subscribe(kpidata => {
        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 7; i++) {
            
            this.yearsArray.push(this.createyearItem(kpidata[i]));
          }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }


  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
      // Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }

    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.defaultyear;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    objKPITarget.tenantUno = this.tenantUno;
    objKPITarget.foreCastType = 2;
    
    this.restApi.addKpiTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'SLA Target Saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSLA();
        }

        this.modalRef.hide();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  saveTarget() {
    this.submitClicked = true;
    if (this.kpiTargetForm.valid) {
      this.AddEditKPITarget(this.kpiTargetForm.value);
    }
  }
}
